export default {
  data() {
    return {
      hoverTimeout: null,
      resourceDroppped: false,
      animation: null,
      renamingSection: false,
    };
  },

  computed: {
    teamSlug() {
      return this.$store.getters.getTeamSlug;
    },
    flatBoards() {
      return this.$store.getters.getFlatBoards;
    },
    sidebarPageDragging() {
      return this.$store.getters.getSidebarDragging.type === 'page';
    },
    sidebarBoardDragging() {
      return this.$store.getters.getSidebarDragging.type === 'board';
    },
    pagesObjects() {
      return this.$store.getters.getPages;
    },
    currentProjectId() {
      return this.$store.getters.getCurrentProjectId;
    },
    isAdmin() {
      return this.currentRole === 'admin';
    },
    isOwner() {
      return this.currentRole === 'owner';
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
    myUserId() {
      return this.$store.getters.getUserId;
    },
  },

  methods: {
    isMyProject(id) {
      return id === this.myUserId;
    },
    dragEnd(evt) {
      this.clearDropTargetAndDraggedEntity();
      if (evt.item.classList.contains('ghost-drag')) {
        evt.item.classList.remove('ghost-drag');
      }
    },
    clearDropTargetAndDraggedEntity() {
      this.$store.dispatch('setSidebarDragging', {});
      this.$store.dispatch('setDraggedEntity', {});
      this.$store.dispatch('setDropTargetId', '');
      this.$store.dispatch('setDraggingEntityProjectFromId', '');
      this.$store.dispatch('setDraggingSidebarItem', false);
    },
    removeHoverTimeout() {
      if (this.animation) {
        this.animation.cancel();
      }
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
    },
    clearProjectPreview() {
      this.$store.dispatch('displayProjectPreviewBoards', false);
      this.$store.dispatch('setProjectPreview', {});
      this.$store.dispatch('clearProjectPreviewBoards');
    },
    cloneItem(evt) {
      evt.clone.classList.add('cloned-element');
      return evt.clone;
    },
    checkMove(evt) {
      if (
        evt.to.className.includes('draggable-sidebar-boards') ||
        evt.to.className.includes('draggable-sidebar-pages') ||
        evt.to.className.includes('draggable-sidebar-child-pages')
      ) {
        this.$store.dispatch('setDropTargetId', `pr-${evt.to.dataset.projectId}`);
      }
    },
    renameSection(value) {
      this.renamingSection = value;
    },
  },
};
